/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { computed } from '@ember/object';
import Component from '@ember/component';

@tagName('')
export default class Unsuppress extends Component {
  // eslint-disable-next-line getter-return
  @computed('category')
  get _confirmationModalCategoryText() {
    if (this.category === 'bounces') {
      return 'bounced';
    } else if (this.category === 'spam_reports') {
      return 'been marked as spam';
    }
  }
}
